module.exports = new __parcel__URL__("grass.85073952.webp").toString();